import * as React from "react";

import { AppContextRole, Authorization, TokenType } from "../types";
import storage from "../storage";
import { useStoreActions, useStoreState } from "../store";
import Service from "../common/Services/Service";
import { oAuth2Client } from "./useAuthorizeWithParams";
import * as fetch from "../common/Services/fetch";
import AuthService from "../services/Auth";

function useServiceSetup() {
  const isSetup = useStoreState((state) => state.isSetup);
  const setIsSetup = useStoreActions((actions) => actions.setIsSetup);
  const setTokens = useStoreActions((actions) => actions.auth.setTokens);
  const reset = useStoreActions((actions) => actions.reset);
  const accessToken = useStoreState((state) => state.auth.tokens?.accessToken);

  const teardown = React.useCallback(async () => {
    try {
      reset();

      if (accessToken) {
        oAuth2Client.revokeToken(accessToken);
      }

      Service.teardown();

      await storage.clearAuthorization();
      await storage.clearPreferences();
    } catch (err) {
      console.log("err = ", err);
    } finally {
      setIsSetup(Service.isSetup());
      console.log("teardown successfull - isSetup = ", Service.isSetup());
    }
  }, [setIsSetup]);

  const setup = React.useCallback(
    async ({
      role,
      tokens,
    }: {
      role: AppContextRole;
      tokens: Authorization;
    }) => {
      fetch.onUnauthorized(async () => {
        try {
          if (tokens) {
            fetch.setAuthorizationHeader({
              ...tokens,
              tokenType: TokenType.Refresh,
            });
  
            const { accessToken } = await AuthService.refreshCurrentUser();
  
            const nextTokens = {
              ...tokens,
              accessToken,
            };
  
            await setup({ role, tokens: nextTokens });
          }
        } catch (error) {
          
        }
        
      });

      try {
        Service.setup({ tokens, role });
        setTokens(tokens);

        await storage.storeAuthorization(tokens);
        await storage.storePreferences({ role });
      } catch (err) {
        console.log("err = ", err);
        await teardown();
      } finally {
        setIsSetup(Service.isSetup());
        console.log("setup successfull - isSetup = ", Service.isSetup());
      }
    },
    [teardown, setIsSetup, setTokens, reset]
  );

  return {
    isSetup,
    setup,
    teardown,
  };
}

export default useServiceSetup;
